import React, { useEffect, useState } from 'react';
import { TOPUPS_COLLECTION } from '../../constants';
import db from '../../firebaseConfig';
import InfiniteScroll from 'react-infinite-scroll-component';
import TopupCard from './TopupCard';
import LoadingIndicator from '../layouts/LoadingIndicator';
import AlertDialog from '../layouts/AlertDialog';
import { connect } from 'react-redux';
import { updateTopups, updateTopupsFromCollections } from '../../redux/topup/topupActions';

// const copied = () => toast.success('Always at the bottom', {position: 'bottom-center',});

const TopupPage = ({ auth, topup, updateTopups, updateTopupsFromCollections }) => {
    const { topups, hasMore, lastDocId } = topup;
    
    const [alert, setAlert] = useState({ show: false, isloading: false, id: null, });
    const [sortBy, setSortBy] = useState('');
    const [alertStatusUpdate, setAlertStatusUpdate] = useState({ show: false, isloading: false, id: null, status: null, });
    
    useEffect(() => {
        if(topups.length === 0) {
            return getData();
        }
    }, []);

    const getData = async () => await db.collection(TOPUPS_COLLECTION)
            .where('createdAt', '>=', Date(Date.now().year, Date.now().month, Date.now().day-7))
            .orderBy('createdAt','desc').limit(15).get()
            .then((collections) => updateTopupsFromCollections(collections));

    const fetchTopupsData = async () => {
        if(lastDocId) {
            return await db.collection(TOPUPS_COLLECTION)
            .where('createdAt', '>=', Date(Date.now().year, Date.now().month, Date.now().day-7))
            .orderBy('createdAt','desc')
            .startAfter(lastDocId)
            .limit(15)
            .get()
            .then((collections) => {
                updateTopupsFromCollections(collections);
            });
        }
    }

    const updateTopUpStatus = async () => {
        setAlertStatusUpdate({
            show: true,
            isloading: true,
            id: alertStatusUpdate.id,
            status: alertStatusUpdate.status,
        });

        if(alertStatusUpdate.status !== null) {
            await db.collection(TOPUPS_COLLECTION).doc(alertStatusUpdate.id).update({status: alertStatusUpdate.status});
            let updatedData = topups.map((topup) => {
                if(topup.uid === alertStatusUpdate.id) {
                    topup.status = alertStatusUpdate.status;
                    return topup;
                } else return topup;
            })
            updateTopups(updatedData);
        }

        setAlertStatusUpdate({ show: false, isloading: false, id: null, status: null, });
    }

    
    const handleDelete = async () => {
        if(auth.user.type === 'super-admin') {
            setAlert({ show: alert.show, isloading: true, id: alert.id, });
    
            const uid = alert.id;
            await db.collection(TOPUPS_COLLECTION).doc(uid).delete();
            
            let updatedData = topups.filter((topup) => topup.uid!==uid);
            updateTopups(updatedData);
    
            setAlert({ show: false, isloading: false, id: null, });
        }
    }

    const handleCancel = () => {
        setAlert({ show: false, isloading: false, id: null, });
        setAlertStatusUpdate({ show: false, isloading: false, id: null, status: null, });
    }

    const topupCard = () => {
        let result = topups;

        if(sortBy === 'pending') {
            const filtered = topups.filter(topup => topup.status === 'pending');
            result = filtered;
        } else if(sortBy === 'processing') {
            const filtered = topups.filter(topup => topup.status === 'processing');
            result = filtered;
        } else if(sortBy === 'canceled') {
            const filtered = topups.filter(topup => topup.status === 'canceled');
            result = filtered;
        } else if(sortBy === 'done') {
            const filtered = topups.filter(topup => topup.status === 'done');
            result = filtered;
        }

        return result.map((topup, index) => {
            return (<TopupCard topup={topup} setAlert={setAlert} setAlertStatusUpdate={setAlertStatusUpdate} key={index} />);
        });
    }

    return (
        <div className="min-h-screen">
            <div className="flex w-full justify-between bg-blue-400 py-4 px-4 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden">
                <p className="m-auto inset-0 text-xl font-semibold leading-7 text-center text-gray-200">Topup Orders</p>
            </div>
            <div className="bg-blue-400 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden">
                <nav className="flex flex-row">
                    <button onClick={() => setSortBy('')} className={sortBy === '' ? "w-full text-gray-500 py-4 px-3 block hover:text-blue-500 focus:outline-none text-blue-500 border-b-2 font-medium border-blue-500" : "w-full text-gray-500 py-4 px-3 block hover:text-blue-500 focus:outline-none"}>All</button>

                    <button onClick={() => setSortBy('pending')} className={sortBy === 'pending' ? "w-full text-gray-500 py-4 px-3 block hover:text-blue-500 focus:outline-none text-blue-500 border-b-2 font-medium border-blue-500" : "w-full text-gray-500 py-4 px-3 block hover:text-blue-500 focus:outline-none"}>Pending</button>

                    <button onClick={() => setSortBy('processing')} className={sortBy === 'processing' ? "w-full text-gray-500 py-4 px-3 block hover:text-blue-500 focus:outline-none text-blue-500 border-b-2 font-medium border-blue-500" : "w-full text-gray-500 py-4 px-3 block hover:text-blue-500 focus:outline-none"}>Processing</button>

                    <button onClick={() => setSortBy('canceled')} className={sortBy === 'canceled' ? "w-full text-gray-500 py-4 px-3 block hover:text-blue-500 focus:outline-none text-blue-500 border-b-2 font-medium border-blue-500" : "w-full text-gray-500 py-4 px-3 block hover:text-blue-500 focus:outline-none"}>Canceled</button>

                    <button onClick={() => setSortBy('done')} className={sortBy === 'done' ? "w-full text-gray-500 py-4 px-3 block hover:text-blue-500 focus:outline-none text-blue-500 border-b-2 font-medium border-blue-500" : "w-full text-gray-500 py-4 px-3 block hover:text-blue-500 focus:outline-none"}>Done</button>
                </nav>
            </div>
            <InfiniteScroll
                dataLength={topups.length} //This is important field to render the next data
                next={fetchTopupsData}
                hasMore={hasMore}
                style={{height: 'unset', overflow: 'unset'}}
                loader={<LoadingIndicator/>}
                endMessage={
                    <p className="text-gray-500 mt-2" style={{ textAlign: 'center' }}>
                    <b>Yay! You have seen it all</b>
                    </p>
                }
                >
                <div className="flex justify-center items-center mt-4">
                    <div className="space-y-4 w-full md:w-1/2 lg:w-1/2 px-4">
                        { topupCard() }
                    </div>
                </div>
            </InfiniteScroll>
            <AlertDialog
                show={alert.show}
                isloading={alert.isloading}
                title="Confirm delete?"
                description="Are you sure want to delete this item. Confirm delete."
                ok="Confirm"
                handleCancel={handleCancel}
                handleOk={handleDelete}
            />
            <AlertDialog
                show={alertStatusUpdate.show}
                isloading={alertStatusUpdate.isloading}
                title="Confirm!"
                description="Are you sure want to update this topup status."
                ok="Confirm"
                handleCancel={handleCancel}
                handleOk={updateTopUpStatus}
            />
        </div>
    );
}


const mapStateToProps = state => {
    return {
        topup: state.topup,
        auth: state.auth
    };
}


const mapDispatchToProps = dispatch => {
    return {
        updateTopups: (latestData) => dispatch(updateTopups(latestData)),
        updateTopupsFromCollections: (collections) => dispatch(updateTopupsFromCollections(collections)),
        // setHasMore: (value) => dispatch(setHasMore(value))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(TopupPage);